<!-- 由 suu 创建于 2021-08-27 星期五 -->
<template>
  <div class="InfoPlan">
    <div class="p-target">{{ info.target }}</div>
    <div class="p-position">训练部位：{{ positionData.join('，') }}</div>
    <!-- 部位分布图 -->
    <GymPosition
      :position="positionData"
      :gender="info.gender == '男' ? 1 : 2"
    ></GymPosition>
    <div class="p-acts" v-if="showActMore && act_list_info">
      <div class="act-item" v-for="(item, index) in act_list_info" :key="index">
        <div class="i-dot"></div>
        <div class="i-name"
          >{{ item.a_name }}
          <div class="i-level">
            {{ item.l_text }}
          </div>
          <div class="i-desc" v-if="item.actionText">
            <span>{{ item.actionText }}</span>
          </div>
        </div>
        <!-- <div class="i-line"></div> -->
        <!-- <div class="i-level" :class="{ 'i-level-h': item.l_text == '高阶' }">
          {{ item.l_text }}
        </div> -->
      </div>
    </div>
    <!-- 为加入课程定制时 默认展开撑起内容 -->
    <!-- <div class="p-btn user-btn" @click="showActMore = !showActMore">
      {{ showActMore ? '收起' : '查看动作组' }}
      <van-icon :name="showActMore ? 'arrow-up' : 'arrow-down'" />
    </div> -->
  </div>
</template>

<script>
import GymPosition from '@/components/GymPosition'

export default {
  name: 'InfoPlan',

  components: { GymPosition },

  props: {
    info: {}
  },

  data() {
    return {
      showActMore: true // 查看动作组
    }
  },

  computed: {
    act_list_info() {
      let list = []
      if (this.info.worm_act) {
        list = this.info.worm_act.concat(this.info.body_act).map((item) => {
          const actionText = item.last_groups
            ? `${item.last_groups}组，每组${
                item.last_time === 0 ? '' : item.last_time + '秒'
              }${
                item.last_times === 0 ? '' : item.last_times + '次'
              }，组间休息${item.rest_time}秒`
            : ''
          return { ...item, actionText }
        })
      }
      return list
    },
    positionData: {
      get() {
        this.$forceUpdate()
        let temp = []
        if (this.info.body_act.length >= 1) {
          this.info.body_act.map((v) => {
            v.a_position.map((p) => {
              if (temp.indexOf(p) === -1) {
                temp.push(p)
              }
            })
          })
        }
        return temp
      },
      set() {}
    }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.InfoPlan {
  width: 91.5vw;
  background-color: #ffffff;
  border-radius: 2.7vw;
  box-sizing: border-box;
  padding: 4vw 5.6vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-top: 4.3vw;
  color: #000000;
  .p-target {
    font-size: 4.8vw;
    font-weight: 600;
  }
  .p-position {
    font-size: 3.2vw;
    color: rgba(0, 0, 0, 0.5);
    margin-top: 1.1vw;
  }
  .p-acts {
    width: 100%;
    box-sizing: border-box;
    .act-item {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      // align-items: center;
      margin-top: 3.2vw;
      position: relative;
      z-index: 1;
      .i-dot {
        width: 2.7vw;
        height: 2.7vw;
        background-color: #ffffff;
        border: solid 0.6vw #7781a2;
        border-radius: 50%;
        box-sizing: border-box;
        margin-top: vw(4);
      }
      .i-name {
        margin-left: 2.7vw;
        font-size: 3.5vw;
      }
      .i-line {
        flex: 1;
        border-top: 0.3vw dashed #ccc;
        margin: 0 3.7vw;
      }
      .i-level {
        font-size: 3vw;
        font-weight: 450;
        color: rgba(0, 0, 0, 0.5);
        margin-top: vw(2);
      }
      .i-desc {
        width: fit-content;
        background-color: #f7f7f7;
        border-radius: 1.1vw;
        border: solid 0.3vw #f1f1f1;
        margin-top: 2.7vw;
        font-size: 3.2vw;
        color: #000;
        padding: 1.1vw 3.2vw;
        box-sizing: border-box;
        font-family: Din;
      }
    }
    .act-item + .act-item {
      margin-top: 3.2vw;
    }
    .act-item:not(:last-of-type):before {
      content: '';
      height: 90%;
      border-left: 0.3vw dashed #979797;
      position: absolute;
      left: vw(5);
      top: vw(18);
      // transform: translateY(100%);
      z-index: -1;
    }
  }
  .p-btn {
    display: flex;
    align-items: center;
    font-size: 3.2vw;
    color: rgba(0, 0, 0, 0.5);
    margin-top: 3.2vw;
    .van-icon {
      margin-left: 2.1vw;
    }
  }
}
</style>
